export default __webpack_public_path__ + "static/media/oxygen.d5a9ec79.svg";